var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimPrize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.42242 10.0435L4.29394 7.1818L10.0745 1.42297L16.0879 7.46008L18.5746 9.95662L9.92252 18.5751L1.42242 10.0435Z",
    fill: "#FCD23E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0251 8.98362L11.0499 0.978883L10.075 0L9.09611 0.974936L0.978887 9.06256L0 10.0375L0.974936 11.0144L8.95007 19.0211L9.92501 20L10.9039 19.0251L19.0211 10.9374L20 9.9625L19.0251 8.98362ZM10.0671 2.38997L17.61 9.96053L9.9329 17.61L2.38998 10.0375L10.0671 2.38997Z",
    fill: "#1D1C1C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7847 12.8705H6.31666C6.02161 12.8705 5.78461 12.6314 5.78461 12.3338V7.88378C5.78461 7.61785 5.97808 7.38852 6.24169 7.35192C8.78101 6.99817 11.3203 6.99817 13.8597 7.35192C14.1209 7.38852 14.3167 7.61785 14.3167 7.88378V12.3338C14.3167 12.629 14.0797 12.8705 13.7847 12.8705Z",
    fill: "#1D1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3167 9.58911H5.78461",
    stroke: "#FCD23E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.36633 9.58911V12.8705",
    stroke: "#FCD23E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8266 9.58911V12.8705",
    stroke: "#FCD23E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4845 8.82135H9.61684C9.17757 8.82135 8.82147 9.17745 8.82147 9.61672C8.82147 10.056 9.17757 10.4121 9.61684 10.4121H10.4845C10.9238 10.4121 11.2799 10.056 11.2799 9.61672C11.2799 9.17745 10.9238 8.82135 10.4845 8.82135Z",
    fill: "#FCD23E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.53214,
    height: 5.7845,
    fill: "white",
    transform: "translate(5.78448 7.086)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimPrize);
export default __webpack_public_path__ + "static/media/claim-prize.466b28521287503cb0d8ac4882cb4619.svg";
export { ForwardRef as ReactComponent };